namespace Gordic.Uda.WebControls {
    let gcontent = Decorators.gcontent;

    /**
     * Vyvěšení na úřední desku
     *
     * @author Jindřich Vácha
     * @since 480.2.0.0
     */
    @gcontent
    export class VyveseniTabs extends GContentBase {

        taskId = "actVyveseniTabs";

        /**
         * Obsah tabu (subtasku) vyvěšení
         * @type {JQuery}
         */
        private $vyveseniDiv: JQuery;
        /**
         * Obsah tabu (subtasku) historie
         * @type {JQuery}
         */
        private $historyDiv: JQuery;
        /**
         * Grid se souborama pro vyvěšení
         * @type {JQuery}
         */
        private $gridVyveseniSoubory: JQuery;
        /**
         * Grid s historií
         * @type {JQuery}
         */
        private $gridHistory: JQuery;
        /**
         * Výpis detailu řádku historie (dynamicky při změně řádku – zdrojem pro data je history grid)
         * @type {JQuery}
         */
        private $historyDetailTabObsah: JQuery;
        /**
         * Grid s vyvěšenýma souborama u záznamu historie
         * @type {JQuery}
         */
        private $gridHistorySoubory: JQuery;

        /**
         * Zda už došlo k loadu vyveseni tab
         * @type {boolean}
         */
        private isVyveseniTabAlreadyLoaded: boolean;

        /**
         * Zda už došlo k loadu hist. tab
         * @type {boolean}
         */
        private isHistorieTabAlreadyLoaded: boolean;

        /**
         * model (definovane jako ContentValues)
         * @type {Gordic.Uda.WebControls.VyveseniTabsDto}
         */
        protected model: Gordic.Uda.WebControls.VyveseniTabsDto;
        /**
         * validators (definovane jako ContentValues)
         * @type {any}
         */
        protected validators: any;

        //-----------------------------------------------------------------------------------------------------
        /**
         * Definice formuláře
         */
        public onContentReady(): void {

            let that = this;

            console.log("Gordic.Uda.WebControls.VyveseniTabs.onContentReady", this);

            this.isVyveseniTabAlreadyLoaded = false;
            this.isHistorieTabAlreadyLoaded = false;


            // start grafické části

            //debugger;

            // GSUBTASKS (taby)
            this.actions.addRange({
                actVyveseniTab: { enabled: true, run: function () { that.LoadVyveseniTab(); } },
                actHistorieTab: { enabled: true, run: function () { that.LoadHistorieTab(); } },
            });

            $("<div>").appendTo(this.element)
                .gsubtasks({
                    params: [
                        {
                            caption:
                                this.model.is_automaticke_vyveseni
                                    ? "jres:24450036" //RC 24450036 : Vyvěšení
                                    : "jres:24450081", //RC 24450081 : Návrh na vyvěšení
                            action: this.actions.actVyveseniTab
                        }, {
                            caption: "jres:24450056", //RC 24450056 : Historie
                            action: this.actions.actHistorieTab
                        },
                    ],
                });

            this.LoadVyveseniTab();

            // akce pro vyvěšení
            this.actions.addRange({
                // TODO: texty do resource
                actVyvesit: {
                    name: "actVyvesit",
                    caption: //"OK",
                        this.model.is_automaticke_vyveseni
                            ? "jres:24450057" //RC 24450057 : Vyvěsit
                            : "jres:24450077", //RC 24450077 : Návrh
                    icon: "fa-save",
                    run: function (ev, ctx) { that.saveDetail(); }
                },
                actCancel: {
                    name: "actCancel", caption: "jres:24450058", icon: "gi-window-close", run: function (ev, ctx) { that.tryClose(); } //RC 24450058 : Zrušit
                },
            });

            // commandbar (tlačítka na spodu okna)
            this.commandBar([
                { action: this.actions.actVyvesit },
                { action: this.actions.actCancel },
            ]);

            if (this.model.flash) {
                this.showFlash({ label: this.model.flash, customClass: 'g-state-info' });
            }

            //if (!this.model.lze_zobrazit) {
            //    this.dialogs.warning("jres:24450022").on("close", function () { that.close() }); //RC 24450022 : Nemáte právo k zobrazení el. obrazu a příloh.
            //}

            // ony ty lze_... věci jsou spřaženy s existencí el. obrazu a příloh => pokud el. obraz neexistuje, tak to jen otravuje...
            //if (!this.model.lze_zverejnit_obr && !this.model.lze_zverejnit_pri) {
            //    this.dialogs.warning("jres:24450023"); //RC 24450023 : Nemáte právo k vyvěšení el. obrazu a příloh.
            //}
            //else if (!this.model.lze_zverejnit_obr) {
            //    this.dialogs.warning("jres:24450024"); //RC 24450024 : Nemáte právo k vyvěšení el. obrazu.
            //}
            //else if (!this.model.lze_zverejnit_pri) {
            //    this.dialogs.warning("jres:24450025"); //RC 24450025 : Nemáte právo k vyvěšení el. příloh.
            //}

        } // onContentReady

        //-----------------------------------------------------------------------------------------------------
        /**
         * 'closing()' okna – test, jestli je možné okno zavřít
         * 
         * @returns {JQueryPromise<any>} promise (resolve = je možné zavřít, reject = není možné zavřít), boolean určuje, jestli přeselektovat seznam (true) nebo ne (false)
         */
        public closing(): JQueryPromise<any> {

            let that = this;

            console.log("VyveseniTabs.closing()", this);

            let nowSoub : SouborDto[] = this.$gridVyveseniSoubory.ggrid("getSelection", false, true);

            console.log("files at start");
            console.log(this.model.souboryZverejnitAtStart);

            console.log("files now");
            console.log(nowSoub);

            

            // kontrola na změněné položky
            let formChanged = this.defaultForm!.gform("hasChanged");

            //let aSoub = this.$gridVyveseniSoubory.ggrid("getSelection", false, true);

            let atStart = "";
            let justNow = "";
            for (let i = 0; i < this.model.souboryZverejnitAtStart!.length; i++) {
                atStart += this.model.souboryZverejnitAtStart![i].ixb + ",";
            }
            for (let j = 0; j < nowSoub.length; j++) {
                justNow += nowSoub[j].ixb + ",";
            }
            console.log("atStart", atStart);
            console.log("justNow", justNow);

            let filesCheckedChanged = (atStart !== justNow);
            //let soubChanged = (x)
            console.log("filesCheckedChanged", filesCheckedChanged);
            console.log("formChanged", formChanged);

            let def = $.Deferred();
            if (formChanged || filesCheckedChanged) {
                // dotaz na zavření
                this.dialogs.confirm(
                    "jres:24450059", //RC 24450059 : Dotaz
                    "jres:24450083") //RC 24450083 : Chcete zavřít okno bez uložení změn?
                    .on("yes", def.resolve )
                    .on("close", def.reject );
            }
            else {
                // pokud se needituje, je možné detail zavřít
                def.resolve();
            }
            return def.promise();
        } // closing

        //-----------------------------------------------------------------------------------------------------
        /**
         * Tab (subtask) 'Vyvěšení'
         */
        private LoadVyveseniTab(): void {

            let that = this;

            console.log("Gordic.Uda.WebControls.VyveseniTabs.VyveseniTab()", this);

            // schovám historii
            if (this.$historyDiv != null) {
                this.$historyDiv.hide();
            }

            // vybuduju vyvěšení
            if (this.isVyveseniTabAlreadyLoaded == false) { // první otevření Subtasku
                this.isVyveseniTabAlreadyLoaded = true;

                console.log("...loading", this);

                this.$vyveseniDiv = $("<div>").appendTo(this.element);

                this.defaultForm = $("<div>")
                    .appendTo(this.$vyveseniDiv)
                    .gform("createFrom", new Gordic.Forms.Form({
                        name: "formVyveseni",
                        layoutDescriptor: "L1M1S1, breaks-200-500"
                        //layoutDescriptor: "L2M2S1"
                    })
                        .addSection()
                        .addRow("jres:24450052") //RC 24450052 : Ixp
                        .addField("gstringbox", {
                            name: "ixp", disabled: true, flag: "required",
                        })
                        .addRow("jres:24450079") //RC 24450079 : Akce
                        .addField("gstringbox", {
                            name: "stav", disabled: true
                        })
                        .addRow("jres:24450016") //RC 24450016 : Název
                        .addField("gstringbox", {
                            name: "nazev", flag: "required"
                        })
                        .addRow("jres:24450017") //RC 24450017 : Popis
                        .addField("gstringbox", {
                            name: "popis", rows: 2
                        })
                        .addRow("jres:24450018") //RC 24450018 : Místo
                        .addField("gselectbox",
                            Gordic.Prefabs.Select.wflsulz(),
                            {
                                name: "ulozisteField",
                                model: "uloziste = ixs_ulz",
                                flag: "required",
                                serverFilters: {
                                    priz_ud: 10
                                }
                            }) // gselectbox
                        .addRow("jres:24450034") //RC 24450034 : Kategorie
                        .addField("gselectbox",
                            Gordic.Prefabs.Select.wfldulz(),
                            {
                                name: "slozkaField",
                                model: "slozka = ktg_dms",
                                flag: "required",
                                serverFilters: {
                                    ixs_ulz: new Gordic.Forms.Dependency("ulozisteField", "ixs_ulz", true)
                                }
                            }) // gselectbox
                        .addRow("jres:24450020") //RC 24450020 : Vyvěšení dne
                        .addField("gdatebox", {
                            name: "dat_od", flag: "required"
                        })
                        .addRow("jres:24450021") //RC 24450021 : Sejmutí dne
                        .addField("gdatebox", {
                            name: "dat_do"
                        })
                    ); // gform

                this.defaultForm.findFields()
                    .gfield("model", "apply", this.model, { initialValues: true })
                    .gfield("model", "validators", this.validators);

                this.$gridVyveseniSoubory = $("<div>")//;  //vytvoreni elementu pro grid
                    .appendTo(this.$vyveseniDiv)
                    .ggrid<SouborDto[]>({
                        multi: true,
                        rowsChecked: "is_checked", //zaskrtne chb, je-li promenna true
                        searchColumns: ["ixb", "soubor", "poznamka"], //sloupce, podle kterych se vyhledava v searchboxu
                        columns: new Gordic.Data.GridFormat()
                            .addTextColumn({
                                name: "typ_txt",
                                caption: "jres:24450029", //RC 24450029 : Typ
                                width: 60,
                                fixedWidth: true
                                //customClass: "ui-disabled"
                            })
                            .addTextColumn({
                                name: "ixb",
                                caption: "jres:24450031", //RC 24450031 : ID souboru
                                fixedWidth: true,
                                width: 110
                            })
                            .addTextColumn({
                                name: "soubor",
                                caption: "jres:24450032", //RC 24450032 : Soubor
                                width: 200
                            })
                            .addTextColumn({
                                name: "poznamka",
                                caption: "jres:24450017", //RC 24450017 : Popis
                                width: 200
                            })
                    })
                    .gautofit(); // bude mít Height až dolu

                if (this.model.souboryVsechny) {
                    let view = new Gordic.Data.View(this.model.souboryVsechny, { key: "ixb" });  //key je dulezity kvuli pripadnemu vyhledavani radku
                    this.$gridVyveseniSoubory.ggrid("setData", view);

                    this.model.souboryZverejnitAtStart = this.$gridVyveseniSoubory.ggrid("getSelection", false, true);                      //nacteni pres referenci

                    if (this.model.souboryVsechny.length == 0) {
                        this.dialogs.warning("jres:24450053"); //RC 24450053 : Doklad nemá žádný el. obraz a přílohy nebo na jejich zveřejnění nemáte dostatečná práva.
                        this.close();
                    }
                }

            } // první otevření Subtasku
            else {
                console.log("...already loaded", this);
            }

            // zobrazím vyvěšení
            if (this.$vyveseniDiv != null) {
                this.$vyveseniDiv.show();
            }
            if (this.actions.actVyvesit != null) {
                this.actions.actVyvesit.visible(true);
            }
        } // LoadVyveseniTab()

        //-----------------------------------------------------------------------------------------------------
        /**
         * Tab (subtask) historie
         */
        private LoadHistorieTab(): void {
            let that = this;

            console.log("Gordic.Uda.WebControls.VyveseniTabs.HistorieTab()", this);

            // schovám vyvěšení
            if (this.$vyveseniDiv != null) {
                this.$vyveseniDiv.hide();
            }
            if (this.actions.actVyvesit != null) {
                this.actions.actVyvesit.visible(false);
            }

            // vybuduju vyvěšení
            if (this.isHistorieTabAlreadyLoaded == false) { // první otevření Subtasku
                this.isHistorieTabAlreadyLoaded = true;

                console.log("...loading", this);

                this.$historyDiv = $("<div>").appendTo(this.element);

                this.$gridHistory = $("<div>")//;  //vytvoreni elementu pro $gridHistory
                    //.height(250)        //nastaveni vysky $gridHistory
                    .appendTo(this.$historyDiv)
                    .gautofit()
                    .ggrid<VyveseniHistDto>({
                        //columnMode: "full", // srazí width sloupců na def. hodnoty
                        marking: false,
                        rowNumbers: false,
                        selection: function (ev, obj) {
                            that.showHistoryDetail();
                        },
                        searchColumns: ["nazev_kat", "nazev_zdroj", "nazev", "popis", "nazev_ref", "zmenu_prov_txt"],
                        columns: new Gordic.Data.GridFormat()
                            .addTextColumn({
                                name: "ixs_ulo_and_por_cislo"
                                , caption: "ID"
                                , width: 130
                                , fixedWidth: true
                                //, visible: false
                            })
                            .addTextColumn({
                                name: "stav"
                                , caption: "jres:24450047" //RC 24450047 : Stav
                                , width: 100
                            })
                            .addTextColumn({
                                name: "nazev_kat"
                                , caption: "jres:24450034" //RC 24450034 : Kategorie
                                , width: 130
                            })
                            .addTextColumn({
                                name: "nazev_zdroj"
                                , caption: "jres:24450035" //RC 24450035 : Zdroj
                                , width: 130
                            })
                            .addDateColumn({
                                name: "dat_od"
                                , caption: "jres:24450036" //RC 24450036 : Vyvěšení
                                , width: 80
                                , fixedWidth: true
                            })
                            .addDateColumn({
                                name: "dat_do"
                                , caption: "jres:24450037" //RC 24450037 : Sejmutí
                                , width: 80
                                , fixedWidth: true
                            })
                            .addTextColumn({
                                name: "nazev"
                                , caption: "jres:24450016" //RC 24450016 : Název
                                , width: 140
                            })
                            .addTextColumn({
                                name: "popis"
                                , caption: "jres:24450017" //RC 24450017 : Popis
                                , width: 150
                            })
                            .addTextColumn({
                                name: "nazev_ref"
                                , caption: "jres:24450038" //RC 24450038 : Vyvěšení provedl
                                , width: 130
                            })
                            .addDateTimeColumn({
                                name: "dat_zmena"
                                , caption: "jres:24450039" //RC 24450039 : Datum změny
                                , width: 130
                                , fixedWidth: true
                            })
                            .addTextColumn({
                                name: "zmenu_prov_txt"
                                , caption: "jres:24450040" //RC 24450040 : Změnu provedl
                                , width: 130
                            })
                    });

                this.$historyDetailTabObsah = $("<div>")
                    .appendTo(this.$historyDiv);


                let view = new Gordic.Data.View(this.model.historie!, { key: "ixs_ulo, por_cislo" });  //key je dulezity kvuli pripadnemu vyhledavani radku
                this.$gridHistory.ggrid("setData", view);

                // aby se to furt nepřenášelo (vykreslený už to je)
                //this.model.historie = null;

                this.$gridHistorySoubory = $("<div>")
                    .appendTo(this.$historyDiv);



            } // první otevření Subtasku
            else {
                console.log("...already loaded", this);
            }

            // zobrazím historii
            if (this.$historyDiv != null) {
                this.$historyDiv.show();
            }

        } // LoadHistorieTab()

        //-----------------------------------------------------------------------------------------------------
        /**
         * Uložení 
         */
        private saveDetail(): void {
            let that = this;

            //////////////////////////////////////
            // provedu všechny kontroly
            //////////////////////////////////////
            console.log("Gordic.Uda.WebControls.VyveseniTabs.saveDetail()", this);

            //Vyvolani validace (pouze v JS bez volani serveru)
            if (!this.defaultForm!.gform("isValid")) {
                return;
            }

            let ff = this.defaultForm!.findFields().gfield("model", "collect", this.model);

            // checked
            this.model.souboryZverejnit = this.$gridVyveseniSoubory.ggrid("getSelection", false, true);                      //nacteni pres referenci

            if (this.model.souboryZverejnit.length == 0) {
                this.dialogs.warning("jres:24450026"); //RC 24450026 : Není vybrán žádný soubor k vyvěšení.
                return;
            }

            //////////////////////////////////////
            // Už bylo něco vyvěšeno, na to se přeptám
            //////////////////////////////////////
            if (this.model.historie && this.model.historie.length > 0) {
                this.dialogs.confirm(
                    "jres:24450059", //RC 24450059 : Dotaz
                    "jres:24450060" //RC 24450060 : Zveřejnění již bylo provedeno, viz záložka Historie.
                    + "<br/>"
                    + "jres:24450068") //RC 24450068 : Přejete si zveřejnění zopakovat?
                    .on("yes", function () { that.saveDetailReal(); });
            } else {
                this.saveDetailReal();
            }
        } // saveDetail()

        //-----------------------------------------------------------------------------------------------------
        /**
         * Uložení (vlastní)
         */
        private saveDetailReal(): void {
            let that = this;

            console.log("Gordic.Uda.WebControls.VyveseniTabs.saveDetailReal()", this);

            this.call<void>("SaveDetail", { model: this.model } /*, null, { applyValidationResultTo: ff } */)
                .done(function (r) {
                    console.log("VyveseniTabs.saveDetailReal().done()");
                    //console.log("Gordic.Uda.WebControls.Vyveseni.saveDetail.done that", that.model);
                    that.actions.actVyvesit!.enabled(false);
                    let text = "";
                    if (that.model.is_automaticke_vyveseni === true) {
                        text += "jres:24450027"; //RC 24450027 : Vyvěšení bylo úspěšné.
                        text += "<br/>" + "jres:24450076"; //RC 24450076 : Viditelnost na desce je dále řízena datumem vyvěšení a sejmutí.
                    } else {
                        text += "jres:24450074"; //RC 24450074 : Návrh na vyvěšení byl úspěšný.
                        text += "<br/>" + "jres:24450075"; //RC 24450075 : K zobrazení na desce musí projít schválením.
                    }
                    let dlg = that.dialogs.alert(text);
                    dlg.on("close", function () { that.close(); });
                })
                .fail(function (xhr, type, vobj) {
                    console.log("VyveseniTabs.saveDetailReal().fail()");
                    if (type === "validation") {
                        let msg = "jres:24450028" + ":<br/>"; //RC 24450028 : Chyba validace (server)
                        $.each(vobj, function (k, v) {
                            for (let i = 0; i < v.length; i++)
                                msg += k + ": " + v[i].message + "<br/>";
                        });
                        that.dialogs.error(msg);
                    }
                });
        } // saveDetailReal()

        //-----------------------------------------------------------------------------------------------------
        /**
         * Zobrazení detailu k řádku historie (data se berou z gridu – i data gridu souborů)
         */
        private showHistoryDetail(): void {

            let that = this;

            let sel: Gordic.Uda.WebControls.VyveseniHistDto[];
            sel = this.$gridHistory.ggrid("getSelection");
            if (sel.length == 1) {

                let row = sel[0];

                // vyčištění
                this.$historyDetailTabObsah.empty();

                $("<div>")
                    .appendTo(this.$historyDetailTabObsah)
                    .gform("createFrom", new Gordic.Forms.Form({ name: "formNahledHistorieVyveseni", layoutDescriptor: "L1M1S1, breaks-200-500" })
                        .addSection("jres:24450062") //RC 24450062 : Detail historie
                        .addRow("ID").addField("gstaticfield", { name: "ixs_ulo_and_por_cislo" })
                        .addRow("jres:24450047").addField("gstaticfield", { name: "stav" }) //RC 24450047 : Stav
                        .addRow("jres:24450034").addField("gstaticfield", { name: "nazev_kat" }) //RC 24450034 : Kategorie
                        .addRow("jres:24450035").addField("gstaticfield", { name: "nazev_zdroj" }) //RC 24450035 : Zdroj
                        .addRow("jres:24450036").addField("gstaticfield", { name: "dat_od", itemTemplate: "{#:date}" }) //RC 24450036 : Vyvěšení
                        .addRow("jres:24450037").addField("gstaticfield", { name: "dat_do", itemTemplate: "{#:date}" }) //RC 24450037 : Sejmutí

                        //.addSection("&nbsp;")
                        .addRow("jres:24450016").addField("gstaticfield", { name: "nazev" }) //RC 24450016 : Název
                        .addRow("jres:24450017").addField("gstaticfield", { name: "popis" }) //RC 24450017 : Popis
                        .addRow("jres:24450038").addField("gstaticfield", { name: "nazev_ref" }) //RC 24450038 : Vyvěšení provedl
                        .addRow("jres:24450039").addField("gstaticfield", { name: "dat_zmena", itemTemplate: "{#:datetime}" }) //RC 24450039 : Datum změny
                        .addRow("jres:24450040").addField("gstaticfield", { name: "zmenu_prov_txt" }) //RC 24450040 : Změnu provedl

                        .addSection("jres:24450049") //RC 24450049 : Vyvěšené soubory
                    );

                let histFilesGridDiv = $("<div>")
                    .appendTo(this.$historyDetailTabObsah)
                    .ggrid<Gordic.Uda.Interface.SeznamPrilohDto[]>({
                        //columnMode: "fit", // rozšíří width sloupců na šíři gridu
                        columns: new Gordic.Data.GridFormat()
                            .addIconColumn({
                                name: "soubor_pri",
                                caption: "jres:24450051", //RC 24450051 : Typ souboru
                                customClass: "center cursor_help",
                                width: 30,
                                fixedWidth: true,
                                iconTemplate: function (row) {
                                    let pripona = row.soubor_pri;
                                    if (pripona != null) {

                                        switch (pripona) {
                                            case "pdf": return { icon: "fa-file-pdf-o", tooltip: pripona };
                                            case "txt": return { icon: "fa-file-text-o", tooltip: pripona };
                                            case "zip": return { icon: "fa-file-archive-o", tooltip: pripona };
                                            case "doc": return { icon: "fa-file-word-o", tooltip: pripona };
                                            case "docx": return { icon: "fa-file-word-o", tooltip: pripona };
                                            case "xls": return { icon: "fa-file-excel-o", tooltip: pripona };
                                            case "xlsx": return { icon: "fa-file-excel-o", tooltip: pripona };
                                            case "xml": return { icon: "fa-file-code-o", tooltip: pripona };
                                            case "jpg": return { icon: "fa-file-image-o", tooltip: pripona };
                                            case "jpeg": return { icon: "fa-file-image-o", tooltip: pripona };
                                            case "png": return { icon: "fa-file-image-o", tooltip: pripona };
                                            case "gif": return { icon: "fa-file-image-o", tooltip: pripona };
                                            default: return { icon: "fa-file-o", tooltip: pripona };
                                        }
                                    } else {
                                        return null;
                                    }
                                }
                            })
                            .addTextColumn({
                                name: "velikost_txt",
                                caption: "jres:24450050", //RC 24450050 : Velikost
                                width: 120,
                                fixedWidth: true
                            })
                            .addTextColumn({
                                name: "soubor",
                                caption: "jres:24450032", //RC 24450032 : Soubor
                                width: 300
                            })
                            .addTextColumn({
                                name: "poznamka",
                                caption: "jres:24450017", //RC 24450017 : Popis
                                width: 400
                            })
                    })
                    .gautofit(); // bude mít Height až dolu

                // nastavení dat a překreslení gridu
                if (row.SouboryHistorie != null) {
                    let view = new Gordic.Data.View(row.SouboryHistorie, { key: "ixs_ulo, por_cislo, ixs_ulo_pri" });
                    histFilesGridDiv.ggrid("setData", view);
                }

                // naplnění
                this.$historyDetailTabObsah.findFields().gfield("model", "apply", row);
            } // if


        } // showHistoryDetail()

    } // cls
} // ns